'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseFleetInsightSubViewController=require('../../../../../dist-es6/client/features/fleetInsight/components/baseFleetInsightSubViewController');let

FatigueTrendsDirective=class FatigueTrendsDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/features/fleetInsight/components/fatigueTrendsTemplate';
}

get objectBindings(){
return['displayInterval'];
}

get controller(){
return FatigueTrendsDirectiveController;
}

get $inject(){
return[
'$timeout',
'$state',
'$scope',
'fatigueTrendsDataService',
'uncaughtErrorHandler',
'groupTreeService'];

}};let


FatigueTrendsDirectiveController=class FatigueTrendsDirectiveController extends BaseFleetInsightSubViewController{
constructor($timeout,$state,$scope,fatigueTrendsDataService,uncaughtErrorHandler,groupTreeService){
super($state,$scope,fatigueTrendsDataService,uncaughtErrorHandler,groupTreeService);
}};


module.exports=FatigueTrendsDirective;
//# sourceMappingURL=fatigueTrendsDirective.js.map
